// Small encounter-scoped bridge for FT3D door runtime state. The campaign shell owns the
// same-origin iframe and forwards this validated envelope without fetching an encounter blob.

import type { WSMessage } from './types';

type DoorStateMessage = Extract<WSMessage, { type: 'ft3d_door_state' }>;

function handleFt3dDoorState(data: DoorStateMessage): void {
    if (data.schema !== 'ft.ft3d.door-state.v1'
        || !checkIfValidUUID(data.encounter_id)
        || typeof data.opening_id !== 'string'
        || data.opening_id.trim() === ''
        || data.opening_id.length > 191
        || typeof data.open !== 'boolean'
        || !Number.isSafeInteger(Number(data.revision))
        || Number(data.revision) < 1) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-door-state', { detail: data }));
}

type DoorPeekMessage = Extract<WSMessage, { type: 'ft3d_door_peek' }>;

/** Keyhole peek presence (DAFT3D S25): the shell forwards it; the frame just refreshes perception. */
function handleFt3dDoorPeek(data: DoorPeekMessage): void {
    if (data.schema !== 'ft.ft3d.door-peek.v1'
        || !checkIfValidUUID(data.encounter_id)) return;
    window.dispatchEvent(new CustomEvent('ft:ft3d-door-peek', { detail: data }));
}

export { handleFt3dDoorState, handleFt3dDoorPeek };
